export const iconFontAwesomeMapsMagnet = (
	<i className="fa-solid fa-magnet"></i>
);
